/* global VideoPlayer */

/**
 * JW Player support for magnific popup
 */

// Create a contained object instead of global variables
var currentJwplayer = (function() {
    var self = {
        setCurrentPlayer(player) {
            this.player = player;
        },
        setCurrentPlayerElement(playerElement) {
            this.playerElement = playerElement;
        },
        getCurrentPlayer() {
            return this.player;
        },
        getCurrentPlayerElement() {
            return this.playerElement;
        }
    };

    return {
        setCurrentPlayer: self.setCurrentPlayer,
        setCurrentPlayerElement: self.setCurrentPlayerElement,
        getCurrentPlayer: self.getCurrentPlayer,
        getCurrentPlayerElement: self.getCurrentPlayerElement
    };
})();

$.magnificPopup.registerModule('jwplayer', {
    options: {
        markup:
            '<div class="mfp-jw-wrapper">' +
            '<button type="button" class="mfp-close">&times;</button>' +
            '<div id="mfp-jwplayer"></div>' +
            '</div>'
    },

    proto: {
        initJwplayer: function() {},

        setupClonedButton: function(element) {
            currentJwplayer.setCurrentPlayerElement(element);

            // Create a dupe since this gets removed by the Platform Video Player
            var buttonClone = currentJwplayer.getCurrentPlayerElement().cloneNode(true);
            var parentToAddTo = currentJwplayer.getCurrentPlayerElement().parentNode;

            // Put the button copy where the removed button was
            parentToAddTo.appendChild(buttonClone);

            // Set new cloned button to be the player element
            currentJwplayer.setCurrentPlayerElement(buttonClone);
        },

        instantiatePlayer: function() {
            var urlHref = currentJwplayer.getCurrentPlayerElement().getAttribute('href');
            var urlHls = currentJwplayer
                .getCurrentPlayerElement()
                .getAttribute('data-video-url-hls');
            if (!(urlHref || urlHls)) {
                return;
            }
            var player = new VideoPlayer(currentJwplayer.getCurrentPlayerElement(), {
                url: {
                    progressive: urlHref,
                    hls: urlHls
                }
            });
            currentJwplayer.setCurrentPlayer(player);

            // Finish and play video
            player.jwplayer.onReady(() => {
                player.jwplayer.play();
            });
        },

        appendPlayerToPopup: function() {
            if (!currentJwplayer.getCurrentPlayer()) {
                return;
            }
            var playerElement = document.querySelector(
                '#' + currentJwplayer.getCurrentPlayer().element.id
            );
            IsJwplayerContainerReady('#mfp-jwplayer', 100, playerElement);
        },

        getJwplayer: function(item, template) {
            this.updateStatus('ready');
            var isDone = false;

            function magnificPopupSetup() {
                // Setup video and make sure it only does it once
                if (!isDone) {
                    var clickedElement = item.el[0];
                    $.magnificPopup.proto.setupClonedButton(clickedElement);
                    $.magnificPopup.proto.instantiatePlayer();
                    $.magnificPopup.proto.appendPlayerToPopup();

                    if (!currentJwplayer.getCurrentPlayer()) {
                        return;
                    }

                    isDone = true;
                }
            }

            this.ev.on('mfpOpen', function() {
                magnificPopupSetup();
            });

            this.ev.on('mfpChange', function() {
                magnificPopupSetup();
            });

            this.ev.on('mfpBeforeClose', function() {
                var currentPlayer = currentJwplayer.getCurrentPlayer();

                currentPlayer.destroy();
            });

            return template;
        }
    }
});

function uglyJwplayerWrapperHack() {
    var videoObj = $('.jw-video-popup');
    var jwChildWithPop = videoObj.find($('.jw-video-popup'));
    if (jwChildWithPop.length > 0) {
        jwChildWithPop.removeClass('jw-video-popup');
    }
}

function IsJwplayerContainerReady(selector, time) {
    var mfpPlayer = document.querySelector(selector);
    if (mfpPlayer) {
        var playerElement = document.querySelector(
            '#' + currentJwplayer.getCurrentPlayer().element.id
        );
        if (mfpPlayer.hasChildNodes()) {
            mfpPlayer.removeChild(mfpPlayer.firstChild);
        }
        mfpPlayer.appendChild(playerElement);
    } else {
        setTimeout(function() {
            IsJwplayerContainerReady(selector, time);
        }, time);
    }
}

uglyJwplayerWrapperHack();
